import { jsx } from '@emotion/core';
import { COLORS } from '../../constants';
var suggestionListStyles = {
  backgroundColor: COLORS.white,
  border: "1px solid " + COLORS.grays.cardBorder,
  left: 0,
  maxHeight: 84,
  overflowY: 'auto',
  position: 'absolute',
  top: '100%',
  width: '100%',
  zIndex: 10,
  listStyle: 'none',
  margin: 0
};
var suggestionListItemStyles = {
  color: COLORS.grays.darkest,
  fontSize: 14,
  lineHeight: '20px',
  overflow: 'hidden',
  padding: '6px 16px 6px 8px',
  textOverflow: 'ellipsis',
  whiteSpace: 'nowrap',
  '&:hover': {
    backgroundColor: COLORS.grays.background,
    cursor: 'pointer'
  }
};
export var SuggestionList = function SuggestionList(_a) {
  var items = _a.items,
      _onClick = _a.onClick;

  if (!items || items.length === 0) {
    return null;
  }

  return jsx("ul", {
    css: suggestionListStyles
  }, items.map(function (i) {
    return jsx("li", {
      onClick: function onClick() {
        return _onClick(i);
      },
      css: suggestionListItemStyles,
      key: i
    }, i);
  }));
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/@trustpilot/businessapp-patternlibrary/lib/components/Tags/suggestionList.js
// module id = 1206
// module chunks = 0